import React, { useEffect } from 'react';

import { messageIdConcat } from '@utils/message-id-concat';
import { PageHeader } from '@utils/page-header';
import { sendGAEvent } from '@utils/google-analytics';

import { H4, Row } from '@atoms';
import { Section } from '@molecules/section';

import { Header, Root } from '@modules/base';

import { ErrorBox } from './error-box/error-box';
import { errorPageBoxes } from './error-boxes';

type Props = {
  statusCode?: number;
  error?: Error;
};

const m = messageIdConcat('error_page');

export const ErrorPage = ({ statusCode = 404, error }: Props) => {
  const isServerError = statusCode >= 500 || Boolean(error);

  useEffect(() => {
    sendGAEvent('Error', statusCode.toString(), window.location.href);
  }, [statusCode]);

  return (
    <Root>
      {/* META */}
      <PageHeader
        title={{
          id: isServerError
            ? m('meta.title.server_error')
            : m('meta.title.not_found'),
        }}
      />
      {/* HEADER */}
      <Header
        title={{ id: m('page_title') }}
        subtitle={{
          id: isServerError
            ? m('page_subtitle.server_error')
            : m('page_subtitle.not_found'),
        }}
      />
      {/* NAVIGATION */}
      <Section fluid>
        <H4
          message={{ id: m('what_next') }}
          textAlign="center"
          margin={[0, 0, 30]}
        />
        <Row justify="center">
          {errorPageBoxes.map(
            ({ iconType, titleId, subtitleId, linkText, pageLink }) => (
              <ErrorBox
                key={titleId}
                iconType={iconType}
                titleId={titleId}
                subtitleId={subtitleId}
                linkText={linkText}
                pageLink={pageLink}
              />
            ),
          )}
        </Row>
      </Section>
    </Root>
  );
};
